import { Box, Flex, Heading } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SubjectCard } from '@/components/ui/shared/subject/SubjectCard/SubjectCard';
import { thinSubjectsRootQueryOptions } from '@/queries/upgrade/thinSubjects';

export const LandingSubjects: FC = () => {
  const { t } = useTranslation();
  const { data: subjects } = useQuery(thinSubjectsRootQueryOptions(4));

  return (
    <Box>
      <Heading color="black" mb={8}>
        {t('newLanding.subjectsTitle')}
      </Heading>
      <Flex justifyContent="flex-start" flexWrap="wrap" gap={4}>
        {subjects?.map((subject) => (
          <SubjectCard key={subject.id} subject={subject} />
        ))}
      </Flex>
    </Box>
  );
};
